import { Injectable, inject } from '@angular/core';

import { FixtureViewType } from '@cds/betting-offer';
import { EventModel, EventParticipant } from '@frontend/sports/betting-offer/feature/model';
import { ShortNameModule, ShortTeamNamesService } from '@frontend/sports/betting-offer/feature/short-team-names';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';

@Injectable({ providedIn: 'root' })
export class EventNameMapperService {
    private shortTeamNamesService = inject(ShortTeamNamesService);
    private sitecore = inject(Sitecore);

    map(event: EventModel, ignoreShortNamesDynacon?: boolean, shortNameModule = ShortNameModule.Grids): string {
        if (event.participants.length === 2 && !event.isTournamentGame()) {
            return this.getPairName(event, shortNameModule, ignoreShortNamesDynacon);
        }

        return event.name;
    }

    private getPairName(event: EventModel, shortNameModule: ShortNameModule, ignoreShortNamesDynacon?: boolean): string {
        const awayIndicator = event.viewType === FixtureViewType.American ? this.sitecore.globalMessages.AwayIndicator : '-';
        const formatParticipant = (index: number) =>
            this.getParticipantName(event, event.participants[index], shortNameModule, ignoreShortNamesDynacon);

        return `${formatParticipant(0)} ${awayIndicator} ${formatParticipant(1)}`;
    }

    getParticipantName(
        event: EventModel,
        participant: EventParticipant,
        shortNameModule: ShortNameModule,
        ignoreShortNamesDynacon?: boolean,
    ): string {
        if (!participant) {
            return '';
        }
        const shouldUseShortName = this.shortTeamNamesService.shouldUseShortName(
            participant,
            event.sport.id,
            event.league.id,
            shortNameModule,
            ignoreShortNamesDynacon,
        );
        const { shortName, name } = participant;
        if (shouldUseShortName && shortName) {
            return this.shortTeamNamesService.clearShortName(shortName);
        }

        return name;
    }
}
